import { NRIModel } from '../NRIModel';

export class NRIListItems {
  static nriItems: Array<NRIModel> = [] as Array<NRIModel>;

  static get NRIItems() {
    return (this.nriItems = [
  {
    "id": "EE3277BC-2339-44BC-A204-F4E287980F3A",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "4B92EE7F-45BF-42E4-AB5C-E96626BEF0F6",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Bahrain",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "4C299DE2-2A54-44F6-A667-642B24948FB6",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "FE12A0C7-69AF-4F94-9F67-663277A3E093",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Indonesia",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "DA101365-9792-43E9-88E4-7B743EFCD221",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "245CBA8B-FA9C-4E1D-B2E9-93357691D7E9",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Kuwait",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "F737956C-A877-40A2-BB89-720AF89C4B19",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "4459FC43-8614-4F1F-B89C-65A696790C0B",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Malaysia",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "8F1B7F97-01C1-490E-9F18-6194E6D02F12",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "C6D3D3EF-127B-4A9C-8ABD-7B89CFDFCE6F",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Oman",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "2A91C7CC-1CB7-4112-99AF-786993B098CF",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "EDBFE7A8-C20E-47E6-B30B-55E150BC2C70",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Qatar",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "29BAF28F-D919-40B1-A78A-B342AF377583",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "BA30ED7A-D9CB-4CBF-A309-549ACB93C9A2",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Saudi Arabia",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "BB615A92-C4D4-4250-9493-2E5589DD1438",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "7EDD9B7C-7460-48BB-89B9-41983DC728A3",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Singapore",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "20B37076-6232-42E9-87CD-EB091478D88F",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "05B03D34-EF28-44F0-8606-80FF1E7E12F9",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "UAE",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "FD6819AE-5659-4482-A0C6-C1F1B7B5910C",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "DA7F2FBE-C0AA-40CF-B63A-85D638084116",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "Uganda",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  },
  {
    "id": "A693E8AA-BA2C-484A-A7B7-F63FFA777D79",
    "specificulture": null,
    "mixDatabaseColumnId": 0,
    "regex": null,
    "dataType": "Custom",
    "mixDatabaseColumnName": null,
    "mixDatabaseName": null,
    "booleanValue": null,
    "dataId": "715048FA-4A99-4FA2-9D63-334A03208C9C",
    "dateTimeValue": null,
    "doubleValue": null,
    "integerValue": null,
    "stringValue": "USA",
    "encryptValue": null,
    "encryptKey": null,
    "encryptType": 0,
    "createdBy": null,
    "createdDateTime": "0001-01-01T00:00:00",
    "modifiedBy": null,
    "lastModified": null,
    "priority": 0,
    "status": "Deleted",
    "isactive": false,
    "columns": null
  }
]
)
  }
}


